// extracted by mini-css-extract-plugin
export default {"message-in":"TextMessage_message-in__JA8gN","message-out":"TextMessage_message-out__O4Qpu"};